module.exports = __webpack_public_path__ + "static/2-a051ca27b59ff8d4566d5540896c2978.png";